/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloading_Subtitle_File_WaitInputs */

const en_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading subtitle file... please wait...`)
};

const fr_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargement du fichier de sous-titres... veuillez patienter...`)
};

const de_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei wird heruntergeladen... Bitte warten...`)
};

const it_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download del file dei sottotitoli... attendere prego...`)
};

const ru_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка файла субтитров... пожалуйста, подождите...`)
};

const es_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargando archivo de subtítulos... por favor espere...`)
};

const zh_cn2_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在下载字幕文件……请稍候……`)
};

const ja_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイルをダウンロードしています...お待ちください...`)
};

const hi_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबटाइटल फाइल डाउनलोड हो रही है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_downloading_subtitle_file_wait = /** @type {(inputs: Downloading_Subtitle_File_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixando arquivo de legenda... aguarde...`)
};

/**
* | output |
* | --- |
* | "Downloading subtitle file... please wait..." |
*
* @param {Downloading_Subtitle_File_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const downloading_subtitle_file_wait = /** @type {((inputs?: Downloading_Subtitle_File_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloading_Subtitle_File_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_downloading_subtitle_file_wait(inputs)
	if (locale === "de") return de_downloading_subtitle_file_wait(inputs)
	if (locale === "it") return it_downloading_subtitle_file_wait(inputs)
	if (locale === "ru") return ru_downloading_subtitle_file_wait(inputs)
	if (locale === "es") return es_downloading_subtitle_file_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_downloading_subtitle_file_wait(inputs)
	if (locale === "ja") return ja_downloading_subtitle_file_wait(inputs)
	if (locale === "hi") return hi_downloading_subtitle_file_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_downloading_subtitle_file_wait(inputs)
	return en_downloading_subtitle_file_wait(inputs)
});